// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import flipHorizontal1Icon from "@/assets/icons/aop/flip-horizontal-1.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FlipHorizontal1IconProps = Omit<IconProps, "name">;

export function FlipHorizontal1Icon(props: FlipHorizontal1IconProps): React.ReactNode {
  return <Icon name={flipHorizontal1Icon} {...props} />;
}
